// Pre-built Workflow Templates for Max OS Cloud Automation Builder

function n(id, type, subtype, label, x, y, config = {}) {
  return { id, type, subtype, label, x, y, config };
}

function c(from, to, label = '') {
  return { from, to, label };
}

// ─── 1. Welcome Email Sequence ───
const welcomeEmailSequence = {
  id: 'tpl-welcome-email',
  name: 'Welcome Email Sequence',
  description: 'Send a 3-email welcome series to new signups over 7 days',
  category: 'Marketing',
  difficulty: 'Beginner',
  estimatedTime: '5 min',
  icon: 'Mail',
  nodes: [
    n('n1', 'trigger', 'form_submit', 'Form Submitted', 80, 120, { form: 'signup' }),
    n('n2', 'action', 'send_email', 'Send Welcome Email', 300, 120, { template: 'welcome_1', subject: 'Welcome to Max OS Cloud!' }),
    n('n3', 'logic', 'delay', 'Wait 2 Days', 520, 120, { duration: '48h' }),
    n('n4', 'action', 'send_email', 'Send Getting Started', 740, 120, { template: 'welcome_2', subject: 'Getting started with your agent' }),
    n('n5', 'logic', 'delay', 'Wait 5 Days', 960, 120, { duration: '120h' }),
    n('n6', 'action', 'send_email', 'Send Pro Tips', 1180, 120, { template: 'welcome_3', subject: 'Pro tips for power users' }),
    n('n7', 'end', 'end_flow', 'End Flow', 1400, 120, {}),
  ],
  connections: [
    c('n1', 'n2'), c('n2', 'n3'), c('n3', 'n4'), c('n4', 'n5'), c('n5', 'n6'), c('n6', 'n7'),
  ],
};

// ─── 2. Lead Nurturing (5-step) ───
const leadNurturing = {
  id: 'tpl-lead-nurturing',
  name: 'Lead Nurturing (5-step)',
  description: 'Nurture leads with a 5-step email sequence based on engagement',
  category: 'Sales',
  difficulty: 'Intermediate',
  estimatedTime: '15 min',
  icon: 'Users',
  nodes: [
    n('n1', 'trigger', 'webhook', 'Webhook Received', 80, 120, { endpoint: '/api/webhooks/lead' }),
    n('n2', 'ai', 'ai_classify', 'AI Classify Lead', 300, 120, { model: 'lead_scoring' }),
    n('n3', 'logic', 'switch', 'Switch by Score', 520, 120, { field: 'lead_score' }),
    n('n4', 'action', 'send_email', 'Send High-Value Content', 740, 40, { template: 'case_study' }),
    n('n5', 'action', 'send_email', 'Send Nurture Email', 740, 120, { template: 'nurture_general' }),
    n('n6', 'action', 'send_slack', 'Notify Sales Team', 740, 200, { channel: '#sales' }),
    n('n7', 'logic', 'delay', 'Wait 3 Days', 960, 120, { duration: '72h' }),
    n('n8', 'action', 'send_email', 'Send Follow-up', 1180, 120, { template: 'follow_up' }),
    n('n9', 'end', 'end_flow', 'End Flow', 1400, 120, {}),
  ],
  connections: [
    c('n1', 'n2'), c('n2', 'n3'),
    c('n3', 'n4', 'High'), c('n3', 'n5', 'Medium'), c('n3', 'n6', 'Low'),
    c('n4', 'n7'), c('n5', 'n7'), c('n6', 'n7'),
    c('n7', 'n8'), c('n8', 'n9'),
  ],
};

// ─── 3. Cart Abandonment Recovery ───
const cartAbandonment = {
  id: 'tpl-cart-abandonment',
  name: 'Cart Abandonment Recovery',
  description: 'Recover abandoned carts with a 3-step email recovery sequence',
  category: 'Sales',
  difficulty: 'Intermediate',
    estimatedTime: '10 min',
  icon: 'ShoppingCart',
  nodes: [
    n('n1', 'trigger', 'webhook', 'Webhook Received', 80, 120, { endpoint: '/api/webhooks/cart' }),
    n('n2', 'logic', 'condition', 'Cart Value > $50?', 300, 120, { field: 'cart_total', op: 'gt', value: 50 }),
    n('n3', 'action', 'send_email', 'Send Discount Email', 520, 60, { template: 'cart_recovery_vip', discount: '15%' }),
    n('n4', 'action', 'send_email', 'Send Reminder Email', 520, 180, { template: 'cart_recovery_standard' }),
    n('n5', 'logic', 'delay', 'Wait 24 Hours', 740, 120, { duration: '24h' }),
    n('n6', 'action', 'send_email', 'Send Last Chance', 960, 120, { template: 'cart_last_chance' }),
    n('n7', 'end', 'end_flow', 'End Flow', 1180, 120, {}),
  ],
  connections: [
    c('n1', 'n2'), c('n2', 'n3', 'Yes'), c('n2', 'n4', 'No'),
    c('n3', 'n5'), c('n4', 'n5'), c('n5', 'n6'), c('n6', 'n7'),
  ],
};

// ─── 4. Customer Support Auto-Response ───
const supportAutoResponse = {
  id: 'tpl-support-auto',
  name: 'Customer Support Auto-Response',
  description: 'Auto-respond to support tickets with AI-powered classification and routing',
  category: 'Support',
  difficulty: 'Advanced',
  estimatedTime: '20 min',
  icon: 'HeadphonesIcon',
  nodes: [
    n('n1', 'trigger', 'email_received', 'Email Received', 80, 120, { folder: 'support' }),
    n('n2', 'ai', 'ai_classify', 'AI Classify Issue', 300, 120, { model: 'support_classifier' }),
    n('n3', 'ai', 'ai_summarize', 'AI Summarize', 520, 120, { max_length: 200 }),
    n('n4', 'logic', 'switch', 'Route by Category', 740, 120, { field: 'category' }),
    n('n5', 'action', 'send_email', 'Send Billing Response', 960, 40, { template: 'billing_faq' }),
    n('n6', 'action', 'send_email', 'Send Tech Response', 960, 120, { template: 'tech_faq' }),
    n('n7', 'action', 'send_slack', 'Escalate to Team', 960, 200, { channel: '#support-escalations' }),
    n('n8', 'end', 'end_flow', 'End Flow', 1180, 120, {}),
  ],
  connections: [
    c('n1', 'n2'), c('n2', 'n3'), c('n3', 'n4'),
    c('n4', 'n5', 'Billing'), c('n4', 'n6', 'Technical'), c('n4', 'n7', 'Escalation'),
    c('n5', 'n8'), c('n6', 'n8'), c('n7', 'n8'),
  ],
};

// ─── 5. Social Media Auto-Poster ───
const socialAutoPoster = {
  id: 'tpl-social-poster',
  name: 'Social Media Auto-Poster',
  description: 'Auto-post content to multiple social media channels on schedule',
  category: 'Marketing',
  difficulty: 'Beginner',
  estimatedTime: '10 min',
  icon: 'Share2',
  nodes: [
    n('n1', 'trigger', 'schedule', 'Schedule Trigger', 80, 120, { cron: '0 10 * * 1-5', timezone: 'America/New_York' }),
    n('n2', 'ai', 'ai_text_gen', 'AI Generate Post', 300, 120, { prompt: 'Generate social media post' }),
    n('n3', 'action', 'http_request', 'Post to Twitter', 520, 60, { url: 'https://api.twitter.com/2/tweets', method: 'POST' }),
    n('n4', 'action', 'http_request', 'Post to LinkedIn', 520, 140, { url: 'https://api.linkedin.com/v2/posts', method: 'POST' }),
    n('n5', 'action', 'send_slack', 'Notify Marketing', 740, 100, { channel: '#marketing' }),
    n('n6', 'end', 'end_flow', 'End Flow', 940, 100, {}),
  ],
  connections: [
    c('n1', 'n2'), c('n2', 'n3'), c('n2', 'n4'), c('n3', 'n5'), c('n4', 'n5'), c('n5', 'n6'),
  ],
};

// ─── 6. Daily Report Generator ───
const dailyReport = {
  id: 'tpl-daily-report',
  name: 'Daily Report Generator',
  description: 'Generate and send daily analytics reports to stakeholders',
  category: 'Operations',
  difficulty: 'Intermediate',
  estimatedTime: '15 min',
  icon: 'BarChart3',
  nodes: [
    n('n1', 'trigger', 'schedule', 'Schedule Trigger', 80, 120, { cron: '0 9 * * *', timezone: 'America/New_York' }),
    n('n2', 'action', 'http_request', 'Fetch Analytics', 300, 120, { url: '/api/analytics/daily', method: 'GET' }),
    n('n3', 'ai', 'ai_summarize', 'AI Summarize Data', 520, 120, { max_length: 500 }),
    n('n4', 'action', 'send_email', 'Send Report', 740, 120, { template: 'daily_report', to: 'team@company.com' }),
    n('n5', 'action', 'send_slack', 'Post to Slack', 960, 120, { channel: '#reports' }),
    n('n6', 'end', 'end_flow', 'End Flow', 1180, 120, {}),
  ],
  connections: [
    c('n1', 'n2'), c('n2', 'n3'), c('n3', 'n4'), c('n4', 'n5'), c('n5', 'n6'),
  ],
};

// ─── 7. Review Request Automation ───
const reviewRequest = {
  id: 'tpl-review-request',
  name: 'Review Request Automation',
  description: 'Automatically request reviews from customers 7 days after purchase',
  category: 'Marketing',
  difficulty: 'Beginner',
  estimatedTime: '5 min',
  icon: 'Star',
  nodes: [
    n('n1', 'trigger', 'webhook', 'Webhook Received', 80, 120, { endpoint: '/api/webhooks/purchase' }),
    n('n2', 'logic', 'delay', 'Wait 7 Days', 300, 120, { duration: '168h' }),
    n('n3', 'action', 'send_email', 'Send Review Request', 520, 120, { template: 'review_request' }),
    n('n4', 'logic', 'condition', 'Review Submitted?', 740, 120, { check: 'webhook_received', timeout: '72h' }),
    n('n5', 'action', 'send_email', 'Send Thank You', 960, 60, { template: 'review_thanks' }),
    n('n6', 'action', 'send_email', 'Send Reminder', 960, 180, { template: 'review_reminder' }),
    n('n7', 'end', 'end_flow', 'End Flow', 1180, 120, {}),
  ],
  connections: [
    c('n1', 'n2'), c('n2', 'n3'), c('n3', 'n4'),
    c('n4', 'n5', 'Yes'), c('n4', 'n6', 'No'),
    c('n5', 'n7'), c('n6', 'n7'),
  ],
};

// ─── 8. Re-engagement Campaign ───
const reengagementCampaign = {
  id: 'tpl-reengagement',
  name: 'Re-engagement Campaign',
  description: 'Re-engage inactive users with a targeted email campaign',
  category: 'Marketing',
  difficulty: 'Intermediate',
  estimatedTime: '15 min',
  icon: 'RefreshCw',
  nodes: [
    n('n1', 'trigger', 'schedule', 'Schedule Trigger', 80, 120, { cron: '0 10 * * 1', timezone: 'America/New_York' }),
    n('n2', 'action', 'db_query', 'Query Inactive Users', 300, 120, { query: 'users_inactive_30d' }),
    n('n3', 'ai', 'ai_text_gen', 'AI Personalize Content', 520, 120, { prompt: 'Personalize re-engagement email' }),
    n('n4', 'action', 'send_email', 'Send Re-engagement', 740, 120, { template: 'reengagement' }),
    n('n5', 'logic', 'delay', 'Wait 5 Days', 960, 120, { duration: '120h' }),
    n('n6', 'logic', 'condition', 'User Re-engaged?', 1180, 120, { check: 'activity_detected' }),
    n('n7', 'action', 'db_query', 'Remove from List', 1400, 120, { query: 'update_engagement_status' }),
    n('n8', 'end', 'end_flow', 'End Flow', 1620, 120, {}),
  ],
  connections: [
    c('n1', 'n2'), c('n2', 'n3'), c('n3', 'n4'), c('n4', 'n5'),
    c('n5', 'n6'), c('n6', 'n7', 'Yes'), c('n6', 'n8', 'No'),
    c('n7', 'n8'),
  ],
};

// ─── 9. Onboarding Drip Sequence ───
const onboardingDrip = {
  id: 'tpl-onboarding-drip',
  name: 'Onboarding Drip Sequence',
  description: 'Guide new users through onboarding with a 7-day drip campaign',
  category: 'Operations',
  difficulty: 'Advanced',
  estimatedTime: '25 min',
  icon: 'GraduationCap',
  nodes: [
    n('n1', 'trigger', 'form_submit', 'Form Submitted', 80, 120, { form: 'signup' }),
    n('n2', 'action', 'send_email', 'Day 0: Welcome', 300, 120, { template: 'onboard_welcome' }),
    n('n3', 'logic', 'delay', 'Wait 1 Day', 520, 120, { duration: '24h' }),
    n('n4', 'action', 'send_email', 'Day 1: Quick Start', 740, 120, { template: 'onboard_quickstart' }),
    n('n5', 'logic', 'delay', 'Wait 2 Days', 960, 120, { duration: '48h' }),
    n('n6', 'action', 'send_email', 'Day 3: Best Practices', 1180, 120, { template: 'onboard_best_practices' }),
    n('n7', 'logic', 'delay', 'Wait 4 Days', 1400, 120, { duration: '96h' }),
    n('n8', 'action', 'send_email', 'Day 7: Check-in', 1620, 120, { template: 'onboard_checkin' }),
    n('n9', 'end', 'end_flow', 'End Flow', 1840, 120, {}),
  ],
  connections: [
    c('n1', 'n2'), c('n2', 'n3'), c('n3', 'n4'), c('n4', 'n5'),
    c('n5', 'n6'), c('n6', 'n7'), c('n7', 'n8'), c('n8', 'n9'),
  ],
};

// ─── 10. Weekly Digest Generator ───
const weeklyDigest = {
  id: 'tpl-weekly-digest',
  name: 'Weekly Digest Generator',
  description: 'Generate and send a weekly digest of key metrics and activity',
  category: 'Operations',
  difficulty: 'Intermediate',
  estimatedTime: '15 min',
  icon: 'Calendar',
  nodes: [
    n('n1', 'trigger', 'schedule', 'Schedule Trigger', 80, 120, { cron: '0 9 * * 1', timezone: 'America/New_York' }),
    n('n2', 'action', 'http_request', 'Fetch Weekly Data', 300, 120, { url: '/api/analytics/weekly', method: 'GET' }),
    n('n3', 'action', 'db_query', 'Query Top Content', 520, 60, { query: 'top_content_7d' }),
    n('n4', 'ai', 'ai_summarize', 'AI Generate Summary', 740, 120, { max_length: 800 }),
    n('n5', 'action', 'send_email', 'Send Digest', 960, 120, { template: 'weekly_digest' }),
    n('n6', 'action', 'send_slack', 'Post Highlights', 1180, 120, { channel: '#general' }),
    n('n7', 'end', 'end_flow', 'End Flow', 1400, 120, {}),
  ],
  connections: [
    c('n1', 'n2'), c('n2', 'n3'), c('n3', 'n4'), c('n4', 'n5'), c('n5', 'n6'), c('n6', 'n7'),
  ],
};

// ─── Template Registry ───
export const workflowTemplates = [
  welcomeEmailSequence,
  leadNurturing,
  cartAbandonment,
  supportAutoResponse,
  socialAutoPoster,
  dailyReport,
  reviewRequest,
  reengagementCampaign,
  onboardingDrip,
  weeklyDigest,
];

export const TEMPLATE_CATEGORIES = {
  Marketing: { label: 'Marketing', color: 'amber', icon: 'Megaphone' },
  Sales: { label: 'Sales', color: 'emerald', icon: 'DollarSign' },
  Support: { label: 'Support', color: 'sky', icon: 'Headphones' },
  Operations: { label: 'Operations', color: 'violet', icon: 'Settings' },
};

export const DIFFICULTY_LEVELS = {
  Beginner: { label: 'Beginner', color: 'emerald' },
  Intermediate: { label: 'Intermediate', color: 'amber' },
  Advanced: { label: 'Advanced', color: 'red' },
};

// ─── Integration Templates ───
export const integrationTemplates = [
  {
    id: 'int-stripe',
    name: 'Stripe',
    description: 'Receive and process Stripe payment events',
    icon: 'CreditCard',
    category: 'Payments',
    webhookEvents: ['payment_intent.succeeded', 'payment_intent.failed', 'customer.created', 'invoice.paid'],
    config: { endpoint: '/api/webhooks/stripe', secret_header: 'Stripe-Signature' },
  },
  {
    id: 'int-shopify',
    name: 'Shopify',
    description: 'Sync orders, customers, and inventory from Shopify',
    icon: 'ShoppingBag',
    category: 'E-Commerce',
    webhookEvents: ['orders/create', 'orders/paid', 'customers/create', 'products/update'],
    config: { endpoint: '/api/webhooks/shopify', secret_header: 'X-Shopify-Hmac-SHA256' },
  },
  {
    id: 'int-hubspot',
    name: 'HubSpot',
    description: 'Sync contacts, deals, and activities with HubSpot CRM',
    icon: 'Database',
    category: 'CRM',
    webhookEvents: ['contact.creation', 'deal.creation', 'deal.propertyChange', 'ticket.creation'],
    config: { endpoint: '/api/webhooks/hubspot', secret_header: 'X-HubSpot-Signature' },
  },
  {
    id: 'int-salesforce',
    name: 'Salesforce',
    description: 'Sync leads, opportunities, and cases with Salesforce',
    icon: 'Cloud',
    category: 'CRM',
    webhookEvents: ['Lead.Created', 'Opportunity.Updated', 'Case.Created', 'Account.Updated'],
    config: { endpoint: '/api/webhooks/salesforce', secret_header: 'X-Salesforce-Signature' },
  },
];

// Helper: get template by ID
export function getTemplateById(id) {
  return workflowTemplates.find(t => t.id === id) || null;
}

// Helper: get templates by category
export function getTemplatesByCategory(category) {
  return workflowTemplates.filter(t => t.category === category);
}

// Helper: import template (returns deep copy with new IDs)
export function importTemplate(templateId) {
  const tpl = getTemplateById(templateId);
  if (!tpl) return null;

  const idMap = {};
  const newNodes = tpl.nodes.map(node => {
    const newId = `node-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
    idMap[node.id] = newId;
    return { ...node, id: newId, config: { ...node.config } };
  });

  const newConnections = tpl.connections.map(conn => ({
    from: idMap[conn.from] || conn.from,
    to: idMap[conn.to] || conn.to,
    label: conn.label,
  }));

  return {
    ...tpl,
    id: `auto-${Date.now()}`,
    name: tpl.name,
    nodes: newNodes,
    connections: newConnections,
    status: 'active',
    createdAt: Date.now(),
    updatedAt: Date.now(),
  };
}
